import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NextPageService } from '@cvx/nextpage';

@Component({
    selector: 'home',
    templateUrl: 'home.component.html',
    styleUrls: ["home.component.css"],
    standalone: false
})

export class HomeComponent {
    title = "Home";
    subtitle = "";
    constructor(private NP: NextPageService, private activatedRoute: ActivatedRoute) {

    }
}